export default {"src":"/_next/static/media/fiveKg_40.515ff10e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};